
    import { defaultTitle } from "./../main"
    import { mapActions, mapGetters } from "vuex"
    import { isDev } from "./../helpers/index"

    import { defineComponent } from "@vue/runtime-core"
    import Prompts from "@/components/prompts/Prompts.vue"
    import TheHeader from "@/components/TheHeader.vue"
    import Playground from "@/components/Playground.vue"
    import SignUp from "@/components/auth/SignUp.vue"
    import LogIn from "@/components/auth/LogIn.vue"
    import Categories from "@/components/Categories.vue"
    import { locStub } from "@vue/compiler-core"
    import ls from "local-storage"
    export default defineComponent({
        components: {
            Categories,
            // LogIn,
            // SignUp,
            Playground,
            TheHeader,
            Prompts,

        },
        data() {
            return {
                tab: null as string | null,
                isDev
            }
        },
        computed: {
            ...mapGetters(["user", "userLoading"]),

        },
        methods: {
            ...mapActions(["getPrompts", "getCategories", "getMyPrompts", "getFavorites"]),

        },

        async created () {
            await this.userLoading
            this.getPrompts({ categoryId: this.$route.params.category })
            this.getMyPrompts({})
            const byIds = (ls as any)("my") || []
            byIds.length && this.getFavorites({ byIds })
            this.getCategories()
            document.title = defaultTitle
        },

        watch: {
            "$route.params.category": {
                handler (newVal) {
                    this.getPrompts({ categoryId: newVal })
                }
            },

        },
    })

  